import React from 'react'

import AddPackageUnitForm from '../../modules/PackageUnit/components/AddPackageUnitForm'
export default function AddPackageUnitPage() {
  return (
    <AddPackageUnitForm/>  )
}
